<template>
  <div class="wlx-signUp-receipt-wrapper">
    <div class="pc-sign-up-main">
      <div class="basic-head-main" :style="{backgroundImage:'url('+headBg+')'}">
        <div class="basic-head-con">
          <div class="head-title-con clearfix">
            <div class="fl basic-book-img-con">
              <img src="~assets/images/basic-book-img.png" alt />
            </div>
            <div class="fr head-title-word">
              <p class="p-title-1">报名回执表</p>
              <p class="p-title-2 p-title-2-1">——北京中物联物流采购培训中心</p>
            </div>
          </div>
        </div>
      </div>
      <div class="signUp-receipt-content">
        <h2 class="signUp-table-title-h2">{{meetDetail.title}}</h2>
        <el-form :model="signForm" :rules="rules" ref="signForm">
          <table class="sign-table-1" border="0" cellspacing="0" cellpadding="0">
            <tr>
              <td colspan="2" class="sign-table-label" width="120px">
                <span class="sp-must-tip">*</span> 申请人姓名
              </td>
              <td colspan="2">
                <el-input v-model="signForm.hostName" autofocus></el-input>
              </td>
              <td colspan="2" class="sign-table-label" width="120px">
                <span class="sp-must-tip">*</span> 申请人手机号
              </td>
              <td colspan="2">
                <el-form-item prop="hostPhoneNum">
                  <el-input v-model="signForm.hostPhoneNum"></el-input>
                </el-form-item>
              </td>
              <td colspan="2" class="sign-table-label" width="120px">
                <span class="sp-must-tip">*</span> 付款方式
              </td>
              <td colspan="2">
                <el-select v-model="signForm.payWay" placeholder="请选择付款方式" clearable>
                  <el-option label="公对公汇款" :value="1"></el-option>
                  <el-option label="现场刷卡" :value="2"></el-option>
                  <el-option label="微信支付（线上培训）" :value="3"></el-option>
                </el-select>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="sign-table-label">
                <span class="sp-must-tip">*</span>入住酒店
              </td>
              <td colspan="6">
                <el-select
                  v-model="signForm.hotel"
                  placeholder="请选择入住酒店"
                  clearable
                  style="width:100%;"
                >
                  <el-option
                    v-for="(item,index) in hotels"
                    :key="index"
                    :label="item.label"
                    :value="item.label"
                  ></el-option>

                  <el-option label="自行安排" value="自行安排"></el-option>
                </el-select>
              </td>
              <td colspan="2" class="sign-table-label">
                <span class="sp-must-tip">*</span>到达时间
              </td>
              <td colspan="2">
                <el-date-picker v-model="signForm.ArriveDate" type="datetime" placeholder="选择到达时间"></el-date-picker>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="sign-table-label" width="120px">
                <span class="sp-must-tip">*</span> 单位名称
              </td>
              <td colspan="10">
                <el-form-item prop="unitName">
                  <el-input v-model="signForm.unitName"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="sign-table-label">
                <span class="sp-must-tip">*</span>地址
              </td>
              <td colspan="4">
                <el-input v-model="signForm.address"></el-input>
              </td>
              <td colspan="2" class="sign-table-label">
                <span class="sp-must-tip">*</span>邮编
              </td>
              <td colspan="4">
                <el-input v-model="signForm.zipCode"></el-input>
              </td>
            </tr>
            <tr>
              <td colspan="12" class="sign-table-label">开票信息(本次会议的参会费一律开增值税普票)</td>
            </tr>
            <tr>
              <td colspan="2" class="sign-table-label">
                <span class="sp-must-tip">*</span> 发票抬头
              </td>
              <td colspan="4">
                <el-form-item prop="invoice">
                  <el-input v-model="signForm.invoice"></el-input>
                </el-form-item>
              </td>
              <td colspan="2" class="sign-table-label">
                <span class="sp-must-tip">*</span> 纳税人识别号
              </td>
              <td colspan="4">
                <el-form-item prop="taxesNum">
                  <el-input v-model="signForm.taxesNum"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="sign-table-label">
                <span class="sp-must-tip">*</span> 开票项目选择
              </td>
              <td colspan="10">
                <div class="sign-up-check-con">
                  <el-checkbox-group v-model="checkList">
                    <el-checkbox label="会议费"></el-checkbox>
                    <el-checkbox label="会务费"></el-checkbox>
                    <el-checkbox label="培训费"></el-checkbox>
                  </el-checkbox-group>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="sign-table-label" width="120px">备注</td>
              <td colspan="10">
                <el-form-item prop="remarks">
                  <el-input type="textarea" v-model="signForm.remarks"></el-input>
                </el-form-item>
              </td>
            </tr>
          </table>
        </el-form>
        <el-table class="sign-table-1" :data="tableData">
          <el-table-column prop="name" label="姓名" width="120px" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.name" size="small"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="sex" label="性别" align="center" width="104px">
            <template slot-scope="scope">
              <el-select v-model="scope.row.sex" placeholder clearable>
                <el-option key="男" label="男" value="男"></el-option>
                <el-option key="女" label="女" value="女"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="post" label="职务" align="center" width="250px">
            <template slot-scope="scope">
              <el-select v-model="scope.row.post" placeholder clearable>
                <el-option key="校领导" label="校领导" value="校领导"></el-option>
                <el-option key="院系领导" label="院系领导" value="院系领导"></el-option>
                <el-option key="专业负责人" label="专业负责人" value="专业负责人"></el-option>
                <el-option key="其他" label="其他" value="其他"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="phoneNum" label="移动电话" align="center" width="232px">
            <template slot-scope="scope">
              <el-input v-model="scope.row.phoneNum" size="small"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="email" label="E-mail" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.email" size="small"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="living" label="单/合住" align="center" width="120px">
            <template slot-scope="scope">
              <el-select v-model="scope.row.living" placeholder>
                <el-option key="单住" label="单住" value="单住"></el-option>
                <el-option key="合住" label="合住" value="合住"></el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
        <div class="add-table-tr-btn" @click="addTableTr">
          <i class="wl-icon-tianjia"></i>
          <span>点击添加一行</span>
        </div>
        <div class="p-sign-up-tip">
          <p>参会说明：</p>
          <p>
            1、报到时间：2019年9月20日8:00-22:00 会议时间：9月21-22日
            报到地点：南昌融创万达嘉华酒店大堂报到处
            地址：江西省南昌市红谷滩新区南龙蟠街333号
          </p>
          <p>2、请尽量提前报名并提前汇款，每个酒店房间的数量有限，我们将按到款及报到的前后顺序安排，若未经报名前来参会者，会议不能确保住房接待。</p>
        </div>
        <div class="submit-btn">
          <el-button type="primary" @click="fanhui">返回</el-button>
          <el-button type="primary" @click="submitTable('signForm',false)" :disabled="isSubmit">提交</el-button>
        </div>
      </div>
    </div>
    <!-- 是否填写提示弹框 -->
    <el-dialog title="提示" :visible.sync="IsTipsDialog" :close-on-click-modal="false" width="600px">
      <div class="wlx-is-fill-signUp-con">
        <p>
          <span>
            您是否已参与报名？如已参与，您可以
            <router-link :to="target" v-if="userInfo.code > 0">直接进入</router-link>
            <a style="color:blue;cursor:pointer;" @click="Gologin()" v-if="userInfo.code < 0">直接进入</a>
            后台编辑相关信息
          </span>
        </p>
        <p class="p-name-pass-tip-con">* 用户名为申请人手机号,初始密码为手机号的后6位</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="IsTipsDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <newLogin :isShow="showObject"></newLogin>
    <!-- 移动端报名 -->
    <el-dialog title="提示" :visible.sync="IsPhoneDialog" :close-on-click-modal="false" width="80%">
      <div class="wlx-is-fill-diaocha-con">
        <p>如已经填报过，请使用电脑端操作</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="IsPhoneDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <div class="ph-sign-up-table-con">
      <div :style="{backgroundImage:'url('+headBg+')'}" class="ph-sign-head-con clearfix">
        <img src="~assets/images/basic-book-img.png" alt class="head-img-val fl" />
        <div class="sign-table-title-con">
          <p class="p-title-1">报名回执表</p>
          <p>——北京中物联物流采购培训中心</p>
        </div>
      </div>
      <div class="sign-up-table-main">
        <h2 class="sign-up-title-h2">{{meetDetail.title}}</h2>
        <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>申请人姓名</span>
        </p>
        <div>
          <el-input v-model="signForm.hostName" autofocus size="small" placeholder="请输入申请人姓名"></el-input>
        </div>
        <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>申请人手机号</span>
        </p>
        <div>
          <el-input v-model="signForm.hostPhoneNum" size="small" placeholder="请输入申请人手机号"></el-input>
        </div>
        <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>入住酒店</span>
        </p>
        <div>
          <el-select
            v-model="signForm.hotel"
            placeholder="请选择入住酒店"
            clearable
            style="width:100%;"
            size="small"
          >
            <el-option
              v-for="(item,index) in hotels"
              :key="index"
              :label="item.label"
              :value="item.label"
            ></el-option>
            <el-option label="自行安排" value="自行安排"></el-option>
          </el-select>
        </div>
        <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>到达时间</span>
        </p>
        <div>
          <el-date-picker
            style="width:100%;"
            size="small"
            v-model="signForm.ArriveDate"
            type="datetime"
            placeholder="选择到达时间"
          ></el-date-picker>
        </div>
        <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>付款方式</span>
        </p>
        <div>
          <el-select
            v-model="signForm.payWay"
            placeholder="请选择付款方式"
            clearable
            size="small"
            style="width:100%;"
          >
            <el-option label="公对公汇款" :value="1"></el-option>   
            <el-option label="现场刷卡" :value="2"></el-option>
            <el-option label="微信支付（线上培训）" :value="3"></el-option>
          </el-select>
        </div>
        <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>单位名称</span>
        </p>
        <div>
          <el-input v-model="signForm.unitName" size="small" placeholder="请输入单位名称"></el-input>
        </div>
        <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>地址</span>
        </p>
        <div>
          <el-input v-model="signForm.address" size="small" placeholder="请输入地址"></el-input>
        </div>
        <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>邮编</span>
        </p>
        <div>
          <el-input v-model="signForm.zipCode" size="small" placeholder="请输入邮编"></el-input>
        </div>
        <h2 class="ph-invoice-title">开票信息(本次会议的参会费一律开增值税普票)</h2>
        <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>发票抬头</span>
        </p>
        <div>
          <el-input v-model="signForm.invoice" size="small" placeholder="请输入发票抬头"></el-input>
        </div>
        <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>纳税人识别号</span>
        </p>
        <div>
          <el-input v-model="signForm.taxesNum" size="small" placeholder="纳税人识别号"></el-input>
        </div>
        <p class="p-form-child-label">
          <span class="sp-must-tip">*</span>
          <span>开票项目选择</span>
        </p>
        <div>
          <el-checkbox-group v-model="checkList">
            <el-checkbox label="会议费"></el-checkbox>
            <el-checkbox label="会务费"></el-checkbox>
            <el-checkbox label="培训费"></el-checkbox>
          </el-checkbox-group>
        </div>
        <p class="p-form-child-label">
          <span class="sp-must-tip"></span>
          <span>备注</span>
        </p>
        <div>
          <el-input type="textarea" v-model="signForm.remarks" placeholder="请输入备注信息"></el-input>
        </div>
        <el-table class="ph-sign-table-1" :data="tableData">
          <el-table-column prop="name" label="姓名" width="120px" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.name" size="small"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="sex" label="性别" align="center" width="104px">
            <template slot-scope="scope">
              <el-select v-model="scope.row.sex" placeholder clearable size="small">
                <el-option key="男" label="男" value="男"></el-option>
                <el-option key="女" label="女" value="女"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="post" label="职务" align="center" width="250px">
            <template slot-scope="scope">
              <el-select v-model="scope.row.post" placeholder clearable size="small">
                <el-option key="校领导" label="校领导" value="校领导"></el-option>
                <el-option key="院系领导" label="院系领导" value="院系领导"></el-option>
                <el-option key="专业负责人" label="专业负责人" value="专业负责人"></el-option>
                <el-option key="其他" label="其他" value="其他"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="phoneNum" label="移动电话" align="center" width="130px">
            <template slot-scope="scope">
              <el-input v-model="scope.row.phoneNum" size="small"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="email" label="E-mail" align="center" width="130px">
            <template slot-scope="scope">
              <el-input v-model="scope.row.email" size="small"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="living" label="单/合住" align="center" width="100px">
            <template slot-scope="scope">
              <el-select v-model="scope.row.living" placeholder size="small">
                <el-option key="单住" label="单住" value="单住"></el-option>
                <el-option key="合住" label="合住" value="合住"></el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
        <div class="add-table-tr-btn" @click="addTableTr">
          <i class="wl-icon-tianjia"></i>
          <span>点击添加一行</span>
        </div>
        <div class="ph-sign-up-tip">
          <p>参会说明：</p>
          <span v-html="meetDetail.explain"></span>
          <!-- <p>
            1、报到时间：2019年9月20日8:00-22:00 会议时间：9月21-22日
            报到地点：南昌融创万达嘉华酒店大堂报到处
            地址：江西省南昌市红谷滩新区南龙蟠街333号
          </p>
          <p>2、请尽量提前报名并提前汇款，每个酒店房间的数量有限，我们将按到款及报到的前后顺序安排，若未经报名前来参会者，会议不能确保住房接待。</p> -->
        </div>
        <div class="submit-btn">
          <el-button type="primary" size="small" @click="fanhui">返回</el-button>
          <el-button
            type="primary"
            size="small"
            @click="submitTable('signForm',true)"
            :disabled="isSubmit"
          >提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MU_UPATE_AUTH, MU_UPATE_SCHOOL } from "store/index";
import Bus from "components/bus.js";
import newLogin from "components/newLogin.vue";
export default {
  data() {
    var reg = /^1\d{10}$/;
    var validatePass = (rule, value, callback) => {
      if (!reg.test(value)) {
        this.$message({
          message: "手机号格式不正确！",
          type: "warning"
        });
      } else {
        callback();
      }
    };
    return {
      IsLogin: false,
      signForm: {
        hostName: "",
        hostPhoneNum: "",
        hotel: "",
        payWay: "",
        ArriveDate: "", // 到达时间
        unitName: "",
        address: "",
        zipCode: "",
        invoice: "",
        taxesNum: "",
        remarks: ""
      },
      checkList: [],
      isSubmit: false,
      rules: {
        unitName: [
          { required: true, message: "请输入活动名称", trigger: "blur" }
        ],
        ArriveDate: [
          { required: true, message: "请输入到达时间", trigger: "blur" }
        ],
        hostPhoneNum: [{ validator: validatePass, trigger: "blur" }]
      },
      tableData: [
        {
          name: "",
          sex: "",
          post: "",
          phoneNum: "",
          email: "",
          living: ""
        },
        {
          name: "",
          sex: "",
          post: "",
          phoneNum: "",
          email: "",
          living: ""
        },
        {
          name: "",
          sex: "",
          post: "",
          phoneNum: "",
          email: "",
          living: ""
        }
      ],
      headBg: require("assets/images/wlx-baic-bg-img.png"),
      timer: "",
      meetDetail: {},
      IsTipsDialog: false,
      showObject: {
        isShow: false
      },
      isInfo: true,
      // 酒店列表
      hotels: [],
      screenWidth: document.body.clientWidth,
      IsPhoneDialog: false,
      phHeadImg: require("assets/images/ph-sigh-up-head.png"),
      phoneTimer:null
    };
  },
  props: {
    signUpId: {
      type: String,
      default: ""
    }
  },
  components: {
    newLogin
  },
  computed: {
    userInfo() {
      return this.$store.state.auth;
    },
    association: function() {
      return this.$store.state.association;
    },
    target: function() {
      let Urlname = "";
      if (this.$store.state.auth.userType === 1) {
        Urlname = "stuBasicInfo";
      } else if (this.$store.state.auth.userType === 2) {
        Urlname = "teaPilotManager";
      } else if (this.$store.state.auth.userType === 3) {
        Urlname = "siteBasicInfo";
      } else if (this.$store.state.auth.userType === 5) {
        Urlname = "managerIndex";
      }
      return { name: Urlname };
    }
  },
  created() {
    var that = this;
    if (localStorage["userId"] !== undefined) {
      that.$store.dispatch(MU_UPATE_AUTH).then(rt => {});
    }
    that.$store.dispatch(MU_UPATE_SCHOOL, { id: window.location.href });
    this.getMeetDetail();
    this.getHotels();
    if (this.screenWidth < 800) {
      this.IsTipsDialog = false;
      this.IsPhoneDialog = true;
    } else {
      this.IsTipsDialog = true;
      this.IsPhoneDialog = false;
    }
  },
  methods: {
    goToHome() {
      this.$router.push({
        name: "meetSignUpDetail",
        params: {
          meetId: this.signUpId
        }
      });
    },
    Gologin() {
      this.IsTipsDialog = false;
      this.showObject = {
        isShow: true
      };
    },
    addTableTr() {
      this.tableData.push({
        name: "",
        sex: "",
        post: "",
        phoneNum: "",
        email: "",
        living: ""
      });
    },
    submitTable(formName, isTrue) {
      var _this = this;
      let situation = [];
      var warningmsg = "";
      var reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
      if (warningmsg != "") {
        this.$message({
          message: warningmsg,
          type: "warning"
        });
        return false;
      }

      if (this.signForm.hostName == "") {
        this.$message({
          message: "请输入申请人姓名",
          type: "warning"
        });
        return false;
      }
      if (this.signForm.hostPhoneNum == "") {
        this.$message({
          message: "请输入申请人号码",
          type: "warning"
        });
        return false;
      } else if (!reg.test(this.signForm.hostPhoneNum)) {
        this.$message({
          message: "手机号格式不正确",
          type: "warning"
        });
        return false;
      }
      if (this.signForm.payWay == "") {
        this.$message({
          message: "请选择付款方式",
          type: "warning"
        });
        return false;
      }
      if (this.signForm.hotel == "") {
        this.$message({
          message: "请选择入住的酒店",
          type: "warning"
        });
        return false;
      }
      if (this.signForm.ArriveDate == "" || this.signForm.ArriveDate == null) {
        this.$message({
          message: "请选择到达时间",
          type: "warning"
        });
        return false;
      }
      if (this.signForm.unitName == "") {
        this.$message({
          message: "请输入单位名称",
          type: "warning"
        });
        return false;
      }
      if (this.signForm.address == "") {
        this.$message({
          message: "请输入地址",
          type: "warning"
        });
        return false;
      }
      if (this.signForm.zipCode == "") {
        this.$message({
          message: "请输入邮编",
          type: "warning"
        });
        return false;
      }
      if (this.signForm.invoice == "") {
        this.$message({
          message: "请输入发票抬头",
          type: "warning"
        });
        return false;
      }
      if (this.signForm.taxesNum == "") {
        this.$message({
          message: "请输入纳税人识别号",
          type: "warning"
        });
        return false;
      }
      if (this.checkList.length == []) {
        this.$message.warning("请选择开票项目");
        return false;
      }
      this.tableData.forEach(item => {
        if (item.name !== "") {
          situation.push(item);
          if (item.living == "") {
            warningmsg = "请完善" + item.name + "的单/合住信息";
          }
          if (item.phoneNum == "") {
            warningmsg = "请完善" + item.name + "的移动电话信息";
          }
          if (item.post == "") {
            warningmsg = "请完善" + item.name + "的职务信息";
          }
        }
      });
      if (warningmsg != "") {
        this.$message({
          message: warningmsg,
          type: "warning"
        });
        return false;
      }

      if (situation.length == 0) {
        this.$message({
          message: "至少添加一名报名人员",
          type: "warning"
        });
        return false;
      }

      this.$refs[formName].validate(valid => {
        if (valid) {
          this.isSubmit = true;
          this.$http
            .post("/api/XOrg/Meeting/addMeetingEnroll", {
              ActivityId: this.signUpId,
              phone: this.signForm.hostPhoneNum,
              displayName: this.signForm.hostName,
              PaymentType: this.signForm.payWay,
              Hotel: this.signForm.hotel,
              ArriveDate: this.signForm.ArriveDate,
              CompanyName: this.signForm.unitName,
              Address: this.signForm.address,
              Note: this.signForm.remarks,
              ZipCode: this.signForm.zipCode,
              Invoice: this.signForm.invoice,
              TaxNumber: this.signForm.taxesNum,
              EnterPerson: JSON.stringify(situation),
              InvoiceItem: JSON.stringify(this.checkList),
              personCount: situation.length
            })
            .then(res => {
              if (res.code > 0) {
                const h = this.$createElement;
                if (isTrue == false) {
                  this.$message({
                    message: h("div", null, [
                      h("p", null, [
                        h("span", { style: "color: #000" }, "报名成功，可登陆"),
                        h("span", { style: "color: red" }, res.username),
                        h("span", { style: "color: #000" }, "账号进行修改管理")
                      ]),
                      h("p", null, [
                        h(
                          "span",
                          { style: "color: #000" },
                          "默认密码为手机号后六位"
                        ),
                        h("span", { style: "color: red" }, res.password),
                        h(
                          "span",
                          { style: "color: #000" },
                          "即将跳转到管理系统..."
                        )
                      ])
                    ]),
                    type: "success",
                    duration: 5000
                  });

                  this.timer = setTimeout(this.goclpp, 5000);
                } else {
                  this.$message({
                    message: h("div", null, [
                      h("p", null, [
                        h("span", { style: "color: #000" }, "报名成功，可使用电脑登陆"),
                        h("span", { style: "color: red" }, res.username),
                        h("span", { style: "color: #000" }, "账号进行修改管理")
                      ]),
                      h("p", null, [
                        h(
                          "span",
                          { style: "color: #000" },
                          "默认密码为手机号后六位"
                        ),
                        h("span", { style: "color: red" }, res.password),
                        h(
                          "span",
                          { style: "color: #000" },
                          "即将返回..."
                        )
                      ])
                    ]),
                    type: "success",
                    duration: 5000
                  });
                  this.phoneTimer = setTimeout(this.goSignUpDetail, 5000);
                }
              } else {
                this.isSubmit = false;
                this.$message({
                  message: res.msg,
                  type: "warning"
                });
              }
            });
        } else {
          this.$message({
            message: "请输入单位名称!",
            type: "warning"
          });
          return false;
        }
      });
    },
    getMeetDetail() {
      this.$http
        .post("/api/XOrg/Special/getSpecialInfo", {
          id: this.signUpId
        })
        .then(res => {
          if (res.code > 0) {
            this.meetDetail = res.info;
          } else {
            this.$message.warning(rst.msg);
          }
        });
    },
    // 获取酒店列表
    getHotels() {
      var that = this;
      this.$http
        .post("/api/XOrg/Meeting/getHotels", {
          activityId: this.signUpId
        })
        .then(res => {
          if (res.code > 0) {
            that.hotels = res.hotels;
          } else {
            that.$message.warning(res.msg);
          }
        });
    },
    goSignUpDetail() {
      this.fanhui();
    },
    goclpp() {
      this.$router.push({
        name: "EnrollManager"
      });
    },
    fanhui() {
      this.$router.go(-1);
    },
    beforeDestroy() {
      clearInterval(this.timer);
      clearInterval(this.phoneTimer);
      this.timer = null;
      this.phoneTimer = null;
    }
  }
};
</script>

<style lang="scss">
</style>
